var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsFunnelTrafficEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    x: -0.059,
    y: -0.059,
    fill: "#D54CFA",
    rx: 32
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5 13.5c1.657 0 3 1.343 3 3v15c0 1.657-1.343 3-3 3h-21c-1.657 0-3-1.343-3-3v-15c0-1.657 1.343-3 3-3h21zm1.5 4.852L24.45 26.85c-.229.171-.53.196-.78.073l-.12-.073L12 18.353V31.5c0 .77.58 1.403 1.325 1.49l.175.01h21c.77 0 1.403-.58 1.49-1.325L36 31.5V18.352zM34.5 15h-21c-.77 0-1.403.58-1.49 1.325l-.009.165L24 25.313l12-8.823-.007-.133c-.066-.703-.619-1.266-1.318-1.347L34.5 15z",
    transform: "translate(8 8)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsFunnelTrafficEmail);
export default __webpack_public_path__ + "static/media/illustrations-funnel-traffic-email.dbc081c7.svg";
export { ForwardRef as ReactComponent };